export default "__VITE_ASSET__B$eQMyHY__"